// src/services/servicioAutenticacion.js (admin)
import api from './api.js';

const CLAVE_TOKEN_ACCESO = 'token_acceso_admin';
const CLAVE_TOKEN_REFRESCO = 'token_refresco_admin';
const CLAVE_TOKEN_ACCESO_LEGADO = 'access_token';
const CLAVE_TOKEN_REFRESCO_LEGADO = 'refresh_token';

function migrarTokensLegado() {
  const tokenLegado = localStorage.getItem(CLAVE_TOKEN_ACCESO_LEGADO);
  const refrescoLegado = localStorage.getItem(CLAVE_TOKEN_REFRESCO_LEGADO);

  const yaMigrado = localStorage.getItem(CLAVE_TOKEN_ACCESO);
  if (!yaMigrado && tokenLegado) {
    localStorage.setItem(CLAVE_TOKEN_ACCESO, tokenLegado);
  }
  if (refrescoLegado && !localStorage.getItem(CLAVE_TOKEN_REFRESCO)) {
    localStorage.setItem(CLAVE_TOKEN_REFRESCO, refrescoLegado);
  }
}

export async function iniciarSesion(correo, clave) {
  try {
    console.log('[DEBUG Autenticacion] Iniciando sesión:', { correo });
    console.log('[DEBUG Autenticacion] Base URL API:', api.defaults.baseURL);
    console.log('[DEBUG Autenticacion] URL completa:', api.defaults.baseURL + '/autenticacion/iniciar');

    const { data } = await api.post('/autenticacion/iniciar', { correo, clave });
    console.log('[DEBUG Autenticacion] Respuesta completa:', JSON.stringify(data, null, 2));
    const tokens = data?.data;
    console.log('[DEBUG Autenticacion] Tokens extraídos:', tokens);
    if (!tokens?.access_token) {
      throw new Error('Token de acceso no recibido');
    }
    localStorage.setItem(CLAVE_TOKEN_ACCESO, tokens.access_token);
    if (tokens.refresh_token) {
      localStorage.setItem(CLAVE_TOKEN_REFRESCO, tokens.refresh_token);
    }
    console.log('[DEBUG Autenticacion] Inicio de sesión exitoso');
    return tokens;
  } catch (error) {
    console.error('[DEBUG Autenticacion] Error en inicio de sesión:', error);
    console.error('[DEBUG Autenticacion] Detalle:', {
      url: error.config?.url,
      method: error.config?.method,
      baseURL: error.config?.baseURL,
      status: error.response?.status,
      statusText: error.response?.statusText,
      data: error.response?.data
    });
    throw error;
  }
}

export function cerrarSesion() {
  localStorage.removeItem(CLAVE_TOKEN_ACCESO);
  localStorage.removeItem(CLAVE_TOKEN_REFRESCO);
  localStorage.removeItem(CLAVE_TOKEN_ACCESO_LEGADO);
  localStorage.removeItem(CLAVE_TOKEN_REFRESCO_LEGADO);
  console.log('[DEBUG Autenticacion] Cierre de sesión completado');
  window.location.href = '/iniciar-sesion';
}

export async function refrescarSesion() {
  migrarTokensLegado();
  const rt = localStorage.getItem(CLAVE_TOKEN_REFRESCO);
  if (!rt) throw new Error('No hay token de refresco');
  const { data } = await api.post('/autenticacion/refrescar', { refresh_token: rt });
  const access = data?.access_token;
  if (access) localStorage.setItem(CLAVE_TOKEN_ACCESO, access);
  return data;
}

export async function obtenerPerfil() {
  const { data } = await api.get('/autenticacion/perfil');
  return data;
}

function decodificarJwt(token) {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    const payload = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const json = decodeURIComponent(
      atob(payload)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(json);
  } catch {
    return null;
  }
}

export function estaAutenticado() {
  migrarTokensLegado();
  const t = localStorage.getItem(CLAVE_TOKEN_ACCESO);
  console.log('[DEBUG Autenticacion] Verificando autenticación:', { hayToken: !!t });
  if (!t) {
    console.log('[DEBUG Autenticacion] No hay token en localStorage');
    return false;
  }
  const p = decodificarJwt(t);
  console.log('[DEBUG Autenticacion] Token decodificado:', { payload: p });
  if (!p || !p.exp) {
    console.log('[DEBUG Autenticacion] Token sin exp, asumiendo válido');
    return true;
  }
  const ahora = Date.now();
  const expMs = p.exp * 1000;
  const valido = expMs > ahora;
  const segundosRestantes = Math.floor((expMs - ahora) / 1000);
  console.log('[DEBUG Autenticacion] Expiración token:', {
    ahora,
    expMs,
    valido,
    segundosRestantes,
    minutosRestantes: Math.floor(segundosRestantes / 60)
  });
  return valido;
}

export function obtenerTokenAcceso() {
  migrarTokensLegado();
  return localStorage.getItem(CLAVE_TOKEN_ACCESO);
}

export default {
  iniciarSesion,
  cerrarSesion,
  refrescarSesion,
  obtenerPerfil,
  estaAutenticado,
  obtenerTokenAcceso
};
